import { AccountCard } from './AccountCard';
import { withI18n } from 'react-i18next';
export default withI18n()(AccountCard);
